import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "pl-10 pr-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置 ")
const _hoisted_4 = { class: "mt-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_6 = { class: "d-flex d-flex-row-reverse" }

import {onBeforeMount, reactive, ref} from "vue";
import {type_consumables, type_fixed} from "@/views/ViewsComponents/officeAssets/OfficeAssetUtils";
import tbMix from "@/global_mixin/tableMixin";
import {exportHandle} from "@/utils";
import {ElMessage} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  props: {
    orgList: null,
    companyList: null,
    categoryList: null,
    assetSearchApi: null,
    exportApi: null
  },
  setup(__props: any) {

const props = __props as {
  orgList: any[],
  companyList: any[],
  categoryList: any[],
  assetSearchApi: (param: any, opt: object) => Promise<any>,
  exportApi: (param: any) => Promise<any>,
}


const tabMaxHeight = ref("520px")
const searchEle = ref()
const searchObj = reactive<{
  orgId: null | number,
  companyId: null | number,
  assetNo: null | string,
  categoryNo: null | string,
  status: string
}>({
  orgId: null,
  companyId: null,
  assetNo: null,
  categoryNo: null,
  status: ''
})
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(props.assetSearchApi)
const searchAsset = () => {
  page.value = 1
  fetchData({
    ...searchObj,
    type: type_consumables,
  })
}
onBeforeMount(()=>{
  searchAsset()
})
const exporting = ref<Boolean>(false)
const exportExcel = () => {
  exporting.value = true
  exportHandle(props.exportApi, {
    orgId: searchObj.orgId ? searchObj.orgId:"",
    companyId: searchObj.companyId ? searchObj.companyId:"",
    assetNo: searchObj.assetNo ?  searchObj.assetNo:"",
    categoryNo: searchObj.categoryNo ?  searchObj.categoryNo:"",
    status: searchObj.status ? searchObj.status:"",
    type: type_consumables,
  }, {contentType: 'formData'}).then(() => {
    exporting.value = false
    ElMessage.success('导出成功')
  }).finally(() => {
    exporting.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "搜索",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              model: _unref(searchObj),
              "label-width": "90px",
              inline: true,
              ref_key: "searchEle",
              ref: searchEle,
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "所属团队:",
                  prop: "orgId",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).orgId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                      placeholder: "所属团队",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "所属公司:",
                  prop: "companyId",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).companyId) = $event)),
                      placeholder: "所属公司",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "资产编号:",
                  prop: "assetNo",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).assetNo,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).assetNo) = $event)),
                      placeholder: "资产编号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "耗材类别:",
                  prop: "categoryNo",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).categoryNo,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).categoryNo) = $event)),
                      placeholder: "耗材类别",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categoryList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.no,
                            label: item.name,
                            value: item.no
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (searchAsset()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {searchEle.value.resetFields();})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: exporting.value,
        loading: exporting.value,
        onClick: exportExcel
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "consumablesAssetStatisticalEle",
      border: "",
      class: "mt-10",
      data: _unref(MI_tableData),
      "row-key": "id",
      "max-height": tabMaxHeight.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "耗材编号",
          prop: "no",
          width: "210",
          fixed: "",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "所属团队",
          prop: "orgName",
          width: "160",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "所属公司",
          prop: "companyName",
          width: "160",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "耗材名称",
          prop: "name",
          width: "160",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "耗材类别",
          prop: "categoryName",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "单位",
          prop: "unit",
          width: "60",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "总数量",
          prop: "initCount",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "剩余数量",
          prop: "count",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "管理员",
          prop: "managerName",
          width: "160",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "采购信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "采购日期",
              prop: "purchasingDate",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "采购人",
              prop: "purchasingUserName",
              width: "160",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "purchasingCurrency",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "采购价格",
              prop: "purchasingPrice",
              align: "right",
              width: "120",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "note",
          width: "120",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_pagination, {
        disabled: _unref(MI_identify),
        background: "",
        small: "",
        total: _unref(MI_total),
        currentPage: _unref(page),
        "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
        "page-size": _unref(size),
        "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
        class: "mt-10",
        "page-sizes": [10, 30, 50, 100, 300, 1000],
        layout: "sizes, prev, pager, next, total, jumper",
        onCurrentChange: _unref(MI_pageChange),
        onSizeChange: _unref(MI_sizeChange)
      }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
    ])
  ]))
}
}

})